import React, { useContext } from "react";
import { Datepicker, Box } from "@flexisaf/flexibull2";
import styled from "styled-components";

import { SchemaContext } from "../container";
import { InputError, InputWrapper } from "../input-wrapper";
import { formatApplicantDate } from "../../utils/helpers";

const FieldStack = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
`;

const FieldLabel = styled.label`
  display: block;
  position: static;
  margin: 0 0 0.4rem;
  padding: 0;
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  color: #5a5368;
  line-height: 1.35;
`;

const DateInput = (props) => {
  const { disabledFields, errorFields, fieldValue, updateFieldValue } =
    useContext(SchemaContext);

  const isValidDate = (d) => d instanceof Date && !isNaN(d);

  const Re = (val) => {
    if (disabledFields.includes(props.keyField)) return;
    if (isValidDate(val)) updateFieldValue(props.keyField, val);
  };

  return (
    <FieldStack>
      {props.props?.label ? (
        <FieldLabel>
          {props.props.label}{" "}
          {props.props?.required ? (
            <span style={{ color: "red" }}>*</span>
          ) : null}
        </FieldLabel>
      ) : null}
      <Datepicker
        {...props.props}
        onChange={Re}
        format="dd MMM yyyy"
        block
        name={props.keyField}
        value={
          fieldValue?.[props.keyField]
            ? new Date(formatApplicantDate(fieldValue?.[props.keyField]))
            : null
        }
        label={null}
        spaceTop={0}
        maxDate={
          props.props.endDate ? new Date(props.props.endDate) : new Date("1/1/2100")
        }
        minDate={
          props.props.startDate
            ? new Date(props.props.startDate)
            : new Date("1/1/1900")
        }
        dayPlaceholder="dd"
        monthPlaceholder="mm"
        yearPlaceholder="yyyy"
        showLeadingZeros={true}
        disabled={disabledFields.includes(props.keyField)}
      />
      <InputWrapper {...props}>
        <InputError>{errorFields[props.keyField]}</InputError>
      </InputWrapper>
    </FieldStack>
  );
};

export default DateInput;
